import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewal-cog',
  templateUrl: './renewal-cog.component.html',
  styleUrls: ['./renewal-cog.component.css']
})
export class RenewalCogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
